import { AllSameKeysEnforcer, AllSameKeyValuesEnforcer } from '../helpers/helpers';

export type ImportType = "performer" | "sponsor" | "exhibitor" | "exhibitorStand" | 'resource' | 'quotes' | 'attendee'
export interface ImportTypes { performer, sponsor, exhibitor, exhibitorStand, resource, attendee }
export const importTypes: AllSameKeyValuesEnforcer<ImportTypes> = { performer:'performer', sponsor:'sponsor', exhibitor:'exhibitor', exhibitorStand:'exhibitorStand', resource: 'resource', attendee:'attendee' };

export const importFields: AllSameKeysEnforcer<ImportTypes> = {
  attendee: [
    { key:'name', label:'Attendee name', isRequired:true, sudo:['attendee','attendeename'], multicolumn:{
      fields:[
        {key:'firstname', label:'First name', sudo:['first','name','attendeefirstname', 'givenname', 'displayname']},
        {key:'lastname', label:'Last name', sudo:['last','surname','attendeelastname','familyname','attendeesurname']},
      ],
      label:'Attendee name'// (First + Last)
    }},
    {key:'email', label:'Attendee contact email'},
    {key:'phone', label:'Attendee contact phone',sudo:['mobile','cell']},
    {key:'line1', label:'Line 1 (e.g. job title)', sudo:['title','jobtitle']},
    {key:'line2', label:'Line 2 (e.g. company)', sudo:['company','companyname']}
  ],
  resource: [
    { key:'name', label:'Resource name', sudo:['company','resourcename'], isRequired:true },
    { key:'description', label:'Description', sudo:['bio','summary']}
  ],
  performer:[
    {key:'name', label:'Performer name', isRequired:true, sudo:['performer','speaker','performername','speakername'], multicolumn:{
      fields:[
        {key:'firstname', label:'First name', sudo:['first','name','speakerfirstname', 'givenname', 'displayname']},
        {key:'lastname', label:'Last name', sudo:['last','surname','speakerlastname','familyname','speakersurname']},
      ],
      label:'Performer name'// (First + Last)
    }},
    {key:'contactName', label:'Performer contact name'},
    {key:'email', label:'Performer contact email'},
    {key:'phone', label:'Performer contact phone',sudo:['mobile','cell']},
    {key:'line1', label:'Line 1 (e.g. job title)', sudo:['title','jobtitle']},
    {key:'line2', label:'Line 2 (e.g. company)', sudo:['company','companyname']},
    {key:'bio', label:'Bio', sudo:['description']},
  ],
  sponsor:[
    {key:'name', label:'Sponsor name', sudo:['company','sponsorname'], isRequired:true},
    {key:'description', label:'Description', sudo:['bio','summary','companyname']},
    {key:'contactName', label:'Sponsor contact name', sudo:['contact']},
    {key:'contactNumber', label:'Sponsor contact phone', sudo:['phone']},
    {key:'contactEmail', label:'Sponsor contact email', sudo:['email']},
    {key:'callToAction', label:'Call to action text', sudo:['cta','button']},
    {key:'callToActionUrl', label:'Call to action URL', sudo:['website','url']},
  ],
  exhibitor:[
    {key:'name', label:'Exhibitor name', sudo:['exhibitor','exhibitorname','company','companyname'], isRequired:true},
    {key:'description', label:'Description', sudo:['bio','summary']},
    {key:'contactName', label:'Exhibitor contact name', sudo:['contact']},
    {key:'contactNumber', label:'Exhibitor contact phone', sudo:['phone']},
    {key:'contactEmail', label:'Exhibitor contact email', sudo:['email']},
    {key:'callToAction', label:'Call to action text', sudo:['cta','button']},
    {key:'callToActionUrl', label:'Call to action URL', sudo:['website','url']},
  ],
  exhibitorStand:[
    {key:'standNumber', label:'Exhibitor Stand Number', sudo: ['number','stand','exhibitornumber'], isRequired:true},
    {key:'standNotes', label:'Exhibitor Stand Notes', sudo: ['notes']},
  ]
}